module.exports = __webpack_public_path__ + "img/SaveMe.cb13e91a.jpg";